export default __webpack_public_path__ + "static/media/mongo.909c449d.png";